import { useIsFetching, useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { QueryKeys } from "constants/queryKeys";
import { ResponseCode } from "constants/response";
import { queryClient } from "index";

import { UserApi } from ".";
import { BalanceType } from "types/user";

export const getMemberDetail = async (username: string) => {
  const res = await UserApi.getProfile({ username });
  const resData = res.data;
  if (res.status === ResponseCode.SUCCESS) {
    queryClient.setQueryData([QueryKeys.MemberDetail, username], resData);
  }
};

export const useGetProfile = (username: string, enabled = true) =>
  useQuery({
    staleTime: Infinity,
    enabled: enabled,
    queryKey: [QueryKeys.MemberDetail, username],
    queryFn: async () => {
      const token = localStorage.getItem("token");
      const response = await UserApi.getProfile({ username });
      if (response.status !== ResponseCode.SUCCESS) {
        throw new Error("username invalid");
      }
      queryClient.setQueryData([QueryKeys.isAuthenticated], true);
      queryClient.setQueryData([QueryKeys.username], username);
      queryClient.setQueryData([QueryKeys.token], token);
      return response.data;
    },
  });

export const useGetBalanceDV = (enabled = true) => {
  const { data: username } = useQuery<string>([QueryKeys.username]);
  const [isInitialReady, setIsInitialReady] = useState(false);

  // Đếm số lượng API khác (không phải GetBalanceDV) đang chạy trong hệ thống/trang
  const otherQueriesFetching = useIsFetching({
    predicate: (query) => query.queryKey[0] !== QueryKeys.GetBalanceDV,
  });

  useEffect(() => {
    // Delay 500ms để toàn bộ các API khởi tạo trang được đăng ký và bắt đầu gửi request
    const timer = setTimeout(() => {
      setIsInitialReady(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return useQuery<BalanceType>([QueryKeys.GetBalanceDV], {
    queryFn: () =>
      UserApi.getMemberBalance({
        username: username as string,
      }),
    onSuccess: (data) => {
      if (data.total) {
        localStorage.setItem("totalBalance", data.total);
      }
    },
    // Chỉ kích hoạt khi: có username, đã qua 500ms khởi tạo trang, và TẤT CẢ các API khác đã chạy xong (otherQueriesFetching === 0)
    enabled: Boolean(
      username && isInitialReady && otherQueriesFetching === 0 && enabled
    ),
    refetchInterval: 1000 * 60 * 2,
  });
};


